__turbopack_context__.v({
  "badge": "styles-module-scss-module__4YpBka__badge",
  "badgeHigh": "styles-module-scss-module__4YpBka__badgeHigh",
  "badgeLow": "styles-module-scss-module__4YpBka__badgeLow",
  "centerStatus": "styles-module-scss-module__4YpBka__centerStatus",
  "enter": "styles-module-scss-module__4YpBka__enter",
  "exit": "styles-module-scss-module__4YpBka__exit",
  "fade-in": "styles-module-scss-module__4YpBka__fade-in",
  "fade-out": "styles-module-scss-module__4YpBka__fade-out",
  "fade-out-80": "styles-module-scss-module__4YpBka__fade-out-80",
  "hidden": "styles-module-scss-module__4YpBka__hidden",
  "hoverContent": "styles-module-scss-module__4YpBka__hoverContent",
  "image": "styles-module-scss-module__4YpBka__image",
  "imageThumb": "styles-module-scss-module__4YpBka__imageThumb",
  "overlayLayer": "styles-module-scss-module__4YpBka__overlayLayer",
  "selected": "styles-module-scss-module__4YpBka__selected",
  "selectionMark": "styles-module-scss-module__4YpBka__selectionMark",
  "slide-in-from-bottom": "styles-module-scss-module__4YpBka__slide-in-from-bottom",
  "slide-in-from-left": "styles-module-scss-module__4YpBka__slide-in-from-left",
  "slide-in-from-right": "styles-module-scss-module__4YpBka__slide-in-from-right",
  "slide-in-from-top": "styles-module-scss-module__4YpBka__slide-in-from-top",
  "slide-out-to-bottom": "styles-module-scss-module__4YpBka__slide-out-to-bottom",
  "slide-out-to-left": "styles-module-scss-module__4YpBka__slide-out-to-left",
  "slide-out-to-right": "styles-module-scss-module__4YpBka__slide-out-to-right",
  "slide-out-to-top": "styles-module-scss-module__4YpBka__slide-out-to-top",
  "zoom-in": "styles-module-scss-module__4YpBka__zoom-in",
  "zoom-out": "styles-module-scss-module__4YpBka__zoom-out",
});
